<mat-dialog-content>
  <mat-spinner [diameter]="35">
  </mat-spinner>
  <div class="message secondary-color-text" [innerHTML]="data.message |safeHtml"></div>
</mat-dialog-content>
